import React from "react";
import Banner from "./Banner";
import WorkoutCategory from "./WorkoutCategory";
import Workout from "./Workout";
import RevibeMembership from "./RevibeMembership";
import Testimonial from "./Testinomials";
import Images from "./ImageGallery";
import WhyChooseRevibe from "./WhyRevibe";
import Quote from "./Quote";
const Home = () => {
  return (
    <div className="mb-24 sm:mb-0">
      <Banner />
      <WorkoutCategory />
      <Workout />
      <RevibeMembership />
      <Testimonial />
      <Images />
      <WhyChooseRevibe />
      <Quote />
    </div>
  );
};

export default Home;
